import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import services from '../views/services.vue'
import company from '../views/company.vue'
import contactus from '../views/contactus.vue'
import news from '../views/news.vue'
import platform from '../views/platform.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/home' //redirect路由重定向
  },
  {
    path: '/home',
    component: home
  },
  {
    path: '/services',
    component: services
  },
  {
    path: '/company',
    component: company
  },
  {
    path: '/contactus',
    component: contactus
  },
  {
    path: '/news',
    component: news
  },
  {
    path: '/platform',
    component: platform
  },
]

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router